import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import {
  TabsContainer,
  Tabs,
  Tab,
  Grid,
  Cell,
  DataTable,
  TableHeader,
  TableRow,
  TableColumn,
  TableBody,
  Checkbox,
  Divider,
  Tooltipped,
} from "react-md";
import GaugeChart from "../charts/GaugeChart";
import BarChart from "../charts/BarChart";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import LineChart from "../charts/LineChart";
import DashboardColors from "./DashboardColors";
import DashboardTooltips from "./DashboardTootips";
import { AppProperties } from '../../common/functions';

const colors = {
  start:"#93FFA4",
  completed:"#005200",
  closed:"#d50000",
  upnext:"#2239ab",
  resume:"#FFDC21",
  black:"#111"
}



const DashboardCard = ({
  assignments,
  handleAssignmentExpand,
  handleCategoryExpand,
  handleAddToPractice,
  handleCategoryChartChange,
  handleCategoryChartTypeChange,
  activeTabIndex,
  isMobile,
  handleTitlePaginationValue,
  handleTakeQuizURL,
  handleDeleteQuiz,
  handleSetGoal,
  showAnalytics,
  handleCarmenAssignmentURL,
  leftSelectedAssignment
}) => {
  const appProperties = AppProperties();
  const [expandedAssignmentId, setExpandedAssignmentId] = useState(null);
  const [expandedCategoryId, setExpandedCategoryId] = useState(null);
  const assignmentRefs = useRef([]);
  const categoryRefs = useRef([]);
  const [filteredAssignments, setFilteredAssignments] = useState([]);

  /* useEffect(() => {
    let newAssigments = []

    if (leftSelectedAssignment?.quizID && leftSelectedAssignment.isMasteryCompleted) {
      // newAssigments = assignments.filter(assign => assign.quizID === leftSelectedAssignment.quizID);
      let index = assignments.findIndex(assign => assign.quizID === leftSelectedAssignment.quizID);
      if (index < 0) return
      newAssigments = [{...leftSelectedAssignment}];
    } else {
      newAssigments = [...assignments];
    }
    console.debug("newAssigments", leftSelectedAssignment, assignments, newAssigments)
    setFilteredAssignments(newAssigments)
  }, [leftSelectedAssignment]) */

  useEffect(() => {
    let newFilteredAssignments = []
    if (leftSelectedAssignment) {
      if (leftSelectedAssignment) {
        leftSelectedAssignment =  {
          ...leftSelectedAssignment, 
          expand: true,
          categories: leftSelectedAssignment?.categories?.map(cat => {
            return {
              ...cat,
              expand: true
            }
          })
        }
      }
      newFilteredAssignments = [{...leftSelectedAssignment}]
    } else {
      newFilteredAssignments = [...assignments]
    }

    setFilteredAssignments([...newFilteredAssignments])
  }, [leftSelectedAssignment, assignments])

  const hasCategoryAddedToPractice =
    assignments &&
    assignments.some((assignment) => {
      return (
        assignment?.categories &&
        assignment?.categories.some((category) => {
          return category.addToPractice;
        })
      );
    });

  const checkIfAtleastOneCatisSelected = (assignmentIndex) => {
    if (assignments && assignments.length > assignmentIndex) {
      const categories = assignments[assignmentIndex].categories;

      if (!categories) return;

      for (const category of categories) {
        if (category.addToPractice) {
          return true;
        }
      }

      return false;
    }
  };

  let cells = [
    { name: "Assignment Score", value: 2 },
    // { name: "Attempt", value: 1 },
    { name: "Questions Completed", value: 30 },
    { name: "Questions Correct", value: 28 },
    { name: "Time Elapsed", value: "12m 23s" },
  ];

  const getCellValue = (cell, assignment) => {
    let value = "";
    switch (cell.name) {
      case "Assignment Score":
        value = assignment.totalScore;
        break;
      case "Attempt":
        value = assignment.totalAttempts;
        break;
      case "Questions Completed":
        value = assignment.totalQuestionsCompleted;
        break;
      case "Questions Correct":
        value = assignment.totalQuestionsCorrect;
        break;
      case "Time Elapsed":
        value = assignment.totalTimeElapsed;

      default:
        break;
    }
    return value == 0 && assignment.state === 'Start' ? "-" : value;
  };

  useEffect(() => {
    /* if (assignmentRefs.current && assignmentRefs.current.length > 0 && assignmentRefs.current[expandedAssignmentId]) {

      if (assignments[expandedAssignmentId].expand) {
        assignmentRefs.current[expandedAssignmentId].scrollIntoView({ behavior: "smooth" });
      } else {
        assignmentRefs.current[expandedAssignmentId].scrollIntoView({ behavior: "smooth", block: "start" });
      }
      
    }

    if (categoryRefs.current && categoryRefs.current.length > 0 && categoryRefs.current[expandedCategoryId]) {
      
      if (assignments[expandedAssignmentId].categories[expandedCategoryId].expand) {
        categoryRefs.current[expandedCategoryId].scrollIntoView({ behavior: "smooth" });
      } else {
        categoryRefs.current[expandedCategoryId].scrollIntoView({ behavior: "smooth", block: "start" });
      }
      
    } */
  }, [assignments]);

  const getColorByAccuracyIndex = (category) => {
    let accuracyIndex =
      category.practiceDetails && category.practiceDetails.length > 0
        ? category.practiceDetails[0]?.accuracyIndex
        : 0;
    
      switch (true) {
        case accuracyIndex <= 50:
          return '#FFAEAE80'
        case accuracyIndex <= 70:
          return '#FFB98780'
        case accuracyIndex <= 90:
          return '#AEDCA7C9'
      
        default:
          return '#AEDCA7C9'
      }

  };
  const getColorByTime = (category) => {
    let time =
      category.practiceDetails && category.practiceDetails.length > 0
        ? category.practiceDetails[0]?.time
        : 0;
    
      switch (true) {
        case time <= 50:
          return '#AEDCA7C9'
        case time <= 70:
          return '#FFB98780'
        case time <= 90:
          return '#FFAEAE80'
      
        default:
          return '#AEDCA7C9'
      }

  };

  const getAccuracyIndexes = (category) => {

    let accuracyIndex = 0

    if (category && category.practiceDetails && category.practiceDetails.length) {
      accuracyIndex = category.practiceDetails[category.practiceDetails.length - 1].accuracyIndex
    }
    console.log("[accuracyIndex, 100 - accuracyIndex]", [accuracyIndex, 100 - accuracyIndex])
    return [accuracyIndex, 100 - accuracyIndex]
  }

  const getAssignmentTimes = (category) => {
    let timeInSec = 0

      if (category && category.practiceDetails && category.practiceDetails.length) {
        timeInSec = category.practiceDetails[category.practiceDetails.length - 1].timeInSec
      }

    return [timeInSec, 100 - timeInSec]
  }

  const getAccuracyIndexByCategory = ( category, assignment) => {
      let accuracyIndex = 0

      if (category && category.practiceDetails && category.practiceDetails.length) {
        accuracyIndex = category.practiceDetails[category.practiceDetails.length - 1].accuracyIndex
      }
      console.debug("assignmentassignment", assignment)
      return accuracyIndex === 0 && assignment.state === 'Start' ? "-" : accuracyIndex
  }

  const getTimeByCategory = ( category, assignment) => {
      let timeInSec = 0

      if (category && category.practiceDetails && category.practiceDetails.length) {
        timeInSec = category.practiceDetails[category.practiceDetails.length - 1].timeInSec
      }

      return timeInSec === 0 && assignment.state === 'Start' ? "-" : timeInSec
  }

  const getCategroyAccuracyRemark = (category) => {
    let categoryRemark = 0;
    let remarkClassName = 'd-none'
    let caretClass = '';
    let plusOrMinus = '';
    let remarkTooltipMsg = '';

    if (category.practiceDetails?.length > 1) {

      /* const lastTwoIndices = category.practiceDetails.reduceRight((indices, item, index) => {
        if (indices.length < 2 && item.accuracyIndex > 0) {
          indices.push(index);
        }
        return indices;
      }, []);
      if (lastTwoIndices.length !== 2) return;

      let lastIndex = lastTwoIndices[1];
      let lastBeforeIndex = lastTwoIndices[0]; */

      let lastIndex = category.practiceDetails.length - 1;
      let lastBeforeIndex = category.practiceDetails.length - 2;

     /*  for (let i = 0; i < category.practiceDetails.length; i++) {
        if (category.practiceDetails[i].isCatSelected) {
          lastBeforeIndex = lastIndex;
          lastIndex = i;
        }
      } */

      /* if (category.practiceDetails[lastIndex].accuracyIndex === 0) {
        return null
      } */
      categoryRemark = category.practiceDetails[lastIndex].accuracyIndex - category.practiceDetails[lastBeforeIndex].accuracyIndex
      
      let lastScore = category.practiceDetails[lastIndex].accuracyIndex
      let lastBeforeScore = category.practiceDetails[lastBeforeIndex].accuracyIndex

      if (lastScore >= lastBeforeScore) {
        remarkClassName = 'text-success'
        plusOrMinus = '+'
        caretClass = 'fa-caret-up'
        remarkTooltipMsg = `Congratulations! Your accuracy has improved from ${lastBeforeScore} to ${lastScore}! Keep up the excellent work!`
      } else {
        remarkClassName = 'text-danger'
        plusOrMinus = '-'
        caretClass = 'fa-caret-down'
        remarkTooltipMsg = `Accuracy decreased from ${lastBeforeScore} to ${lastScore}. Keep pushing forward!`
      }
    }

    return  <div className="position-relative">
      <Tooltipped label={remarkTooltipMsg} position="top" tooltipStyle={{
      width: category.expand ? '100%' :'300px',
      whiteSpace:'pre-line',
      fontSize:"12px"
    }}>
      <small 
        className={remarkClassName} 
      >
      {plusOrMinus}
      {Math.abs(categoryRemark)}
      {/* <i className={`fa ${caretClass} ml-1 `} style={{
        opacity: 0.5,
      }}></i> */}
    </small>
    </Tooltipped>
    </div>
  }

  const getCategoryTimeRemark = (category) => {
    let categoryRemark = 0;
    let remarkClassName = 'd-none'
    let caretClass = '';
    let plusOrMinus = '';
    let remarkTooltipMsg = '';

    if (category.practiceDetails?.length > 1) {

      /* const lastTwoIndices = category.practiceDetails.reduceRight((indices, item, index) => {
        if (indices.length < 2 && item.accuracyIndex > 0) {
          indices.push(index);
        }
        return indices;
      }, []);
      if (lastTwoIndices.length !== 2) return;

      let lastIndex = lastTwoIndices[1];
      let lastBeforeIndex = lastTwoIndices[0]; */

      let lastIndex = category.practiceDetails.length - 1;
      let lastBeforeIndex = category.practiceDetails.length - 2;

     /*  for (let i = 0; i < category.practiceDetails.length; i++) {
        if (category.practiceDetails[i].isCatSelected) {
          lastBeforeIndex = lastIndex;
          lastIndex = i;
        }
      } */


     /*  if (category.practiceDetails[lastIndex].timeInSec === 0) {
        return null
      } */

      let lastTime = category.practiceDetails[lastIndex].timeInSec
      let lastBeforeTime = category.practiceDetails[lastBeforeIndex].timeInSec

      categoryRemark = lastTime - lastBeforeTime
      if (category.practiceDetails[lastIndex].timeInSec > category.practiceDetails[lastBeforeIndex].timeInSec) {
        remarkClassName = 'text-danger'
        plusOrMinus = '+'
        caretClass = 'fa-caret-up'
        remarkTooltipMsg = `The time taken has increased from ${lastBeforeTime} sec to ${lastTime} sec. Keep pushing forward!`
      } else {
        remarkClassName = 'text-success'
        plusOrMinus = '-'
        caretClass = 'fa-caret-down'
        remarkTooltipMsg = `Congratulations! You've reduced the time taken from ${lastBeforeTime} sec to ${lastTime} sec! Well done!`
      }
    }


    return <div className="position-relative">
     <Tooltipped label={remarkTooltipMsg} position="top" tooltipStyle={{
      width: category.expand ? '100%' :'300px',
      whiteSpace:'pre-line',
      fontSize:"12px"
    }}>
      <small className={remarkClassName}
        >
        {plusOrMinus}
        {Math.abs(categoryRemark)}
        {/* <i className={`fa ${caretClass} ml-1 `} style={{
          opacity: 0.5,
        }}></i> */}
    </small>
    </Tooltipped>
    </div>
  }

  const barChartLabels = () => {
    const legendLabels = [
      { name:"Graded",bg: DashboardColors.MASTERY_BAR_BG},
      { name:"Practice",bg: DashboardColors.PRACTICE_BAR_BG},
      { name:"Prior Goal",bg: DashboardColors.PRACTICE_GOAL_BAR_BG},
      { name:"Drag to Set New Goal",bg: DashboardColors.GOAL_BG},
    ]
    return <div className="my-3 d-flex flex-wrap justify-content-center" >
    {legendLabels.map(legendLabel => {
      return <div className="mx-3" size={4} phoneSize={2} key={legendLabel.name}>
      <div className="d-flex align-items-center mb-2">
        <div
          className="custom-box inline-block mr-1"
          style={{
            background: legendLabel.bg,
          }}
        ></div>
        <div className="fontClass-14">{legendLabel.name}</div>
      </div>
    </div>
    })}
  </div>
  }

  // Accuracy
  const getCategoryAccuracyLabels = (category) => {
    let labels = []
    let practiceArr = []
    
    if (category) {  
      if (category.showLineChart) {
        practiceArr = category.practiceDetailsAcross
      } else {
        practiceArr = category.practiceDetails 
      }
    }
    let count = 1;
    practiceArr?.forEach((ele, index) => {
      // if (ele.accuracyIndex > 0) {
        labels.push(count)
        count += 1;
      // }
    })
    labels.push('New Goal')

    return labels
  }

  const getCategoryAccuracyValuesAndColors = (category) => {
    let values = []
    let practiceArr = []
    if (category) {
      
      if (category.showLineChart) {
        practiceArr = category.practiceDetailsAcross
      } else {
        practiceArr = category.practiceDetails 
      }
    }
    practiceArr?.forEach((ele, index) => {
      // if (ele.accuracyIndex > 0) {
        values.push({
          value: ele.accuracyIndex,
          color: ele.practiceCount === 0 ? DashboardColors.MASTERY_BAR_BG : DashboardColors.PRACTICE_BAR_BG,
          quizName: ele.quizName
        })
      // }
    })
    
    if (practiceArr?.length >=0 ) {
      values.push({
        value: category.lastAccuracyGoal ? category.lastAccuracyGoal : 100,
        color:DashboardColors.GOAL_BG
      })
    }

  
    return values
  }

  const getCategoryAccuracyGoals = (category) => {
    let values = []
    category?.practiceDetails?.forEach(ele => {
      if (ele.practiceCount > 0) {
        values.push(ele.accuracyGoal)
      } else {
        values.push(null)
      }
    })
    return values
  }

  // Time

  const getCategoryTimeLabels = (category) => {
    let labels = []
    let practiceArr = []

    if (category) {
      
      if (category.showLineChart) {
        practiceArr = category.practiceDetailsAcross
      } else {
        practiceArr = category.practiceDetails 
      }
    }
    let count = 1;
    practiceArr?.forEach((ele, index) => {
      // if (ele.accuracyIndex > 0) {
        labels.push(count)
        count += 1
      // }
      
    })

    labels.push('New Goal')
    
    return labels
  }

  
  const getCategoryTimeValues = (category) => {
    let values = []
    let practiceArr = []

    if (category) {
      
      if (category.showLineChart) {
        practiceArr = category.practiceDetailsAcross
      } else {
        practiceArr = category.practiceDetails 
      }
    }
    

    practiceArr?.forEach(ele => {
      // if (ele.accuracyIndex > 0) {
        values.push({
          value: ele.timeInSec,
         color: ele.practiceCount === 0 ? DashboardColors.MASTERY_BAR_BG : DashboardColors.PRACTICE_BAR_BG,
         quizName: ele.quizName
        })
      // }
    })

    if (practiceArr?.length >=0) {
      values.push({
        value: category.lastTimeGoal ? category.lastTimeGoal : 20,
        color:DashboardColors.GOAL_BG
      })
    }
    return values
  }


  const getCategoryTimeGoals = (category) => {
    let values = []
    
    category?.practiceDetails?.forEach(ele => {

      if (ele.practiceCount > 0) {
        if (ele.timeGoal === 0) {
          values.push(ele.timeInSec * 0.25)
        } else {
          values.push(ele.timeGoal)
        }
      } else {
        values.push(null)
      }

      
    })

    return values
  }


  const checkIfTimeChartIsLocked = (category) => {
    let accuracy = 0

    if (category && category.practiceDetails) {
      let l = category.practiceDetails?.length

      accuracy = category?.practiceDetails[l-1]?.accuracyIndex ? category?.practiceDetails[l-1]?.accuracyIndex : 0
  
      if (accuracy >= 90) {
        return false
      } 
    }   

    return true
  }


  const getTheMaxTime = (category)  => {
    if (category && category.practiceDetails) {
      let maxTime = category.practiceDetails.reduce((max, detail) => {
        return detail.timeInSec > max ? detail.timeInSec : max;
      }, 0);

      maxTime = Math.round(maxTime / 10) * 10
      maxTime += 30;

      if (maxTime < category.timeMedian) {
        return (category.timeMedian + 30)
      }

      return maxTime;
    }

    return 30;
  }

  const [currentItem, setCurrentItem] = useState(0);
  const itemsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const itemIndex = itemsRef.current.indexOf(entry.target);
            setCurrentItem(itemIndex + 1);
            handleTitlePaginationValue(itemIndex+1)
          }
        });
      },
      { threshold: 1 } // Adjust the threshold as needed
    );

    itemsRef.current.forEach((item) => {
      if (item) {
        observer.observe(item);
      }
      
    });

    // Cleanup observer when component unmounts
    return () => {
      observer.disconnect();
    };
  }, [assignments]);

  const getCustomChipBackgroundColor = (assign) => {
    let bgColor = "red";
   if (assign.state === "Up Next") {
      bgColor = colors.upnext
    } else if (assign.state === "Closed") {
      bgColor = colors.closed
    } else if (assign.state === "Resume") {
      bgColor = colors.resume
    } else if (assign.state === "Start") {
      bgColor = colors.start;
    } else if (assign.state === "Completed" || assign.isMasteryCompleted) {
      bgColor = colors.completed;
    }

    return bgColor;
  }

  const getCustomChipTextColor = (assign) => {

    let color = "white";
    if (assign.state === 'Start' || assign.state === "Resume" && !assign.isMasteryCompleted) {
      color = colors.black
    }

    return color;
  }

  const getAssignmentState = (assignment) => {
    
    if (assignment.state !== "Closed" && assignment.isMasteryCompleted) {
      return "Completed"
    }
    
    if (assignment.state === "Closed") {
      return assignment.state
    }

    if (assignment.ltiQuizID !== "" || appProperties.isLTIStudent) {
      return "Go To Carmen"
    }

    return assignment.state
  }

  const checkIfAssignmentCanBeAttended = (assignment) => {
    
    // Check if assignment is closed
    if (assignment.state === "Closed" || assignment.state === "Completed" || assignment.isMasteryCompleted) return false;

    // Check if assignment is set to future dates
    if (assignment.state === "Up Next") return false;

    // Check if assignment is completed and has allow practice

    return true;
  }

  const checkIfAssignmentCanBePracticed = (assignment) => {
    
    if (assignment.state === "Closed") return false;
    if (assignment.courseID === -1) return true;
    if (assignment.isMasteryCompleted && assignment.allowPractice) return true;

    return false;

  }

  const getToolTipForPracticeBtn = (assignment) => {
    if (assignment.courseID === -1) return null
    if (assignment.state == "Closed") return "Sorry, the assignment has been closed"
    if (!assignment.allowPractice) {
      return "This assignment is not allowed for practice. Please ask the instructor to make this practicable"
    }
    if (assignment.isMasteryCompleted) {
      return null
    }
    return  "Please complete the mastery assignment first";
  }

  const getOpenInTime = (assignment) => {
    const startDate = moment(assignment.startDate, "DD/MM/YYYY");
    const currentDate = moment();
    const dayDiff = startDate.diff(currentDate, "days");
    const hourDiff = startDate.diff(currentDate, "hours");

    const displayValue =
    dayDiff === 0
        ? `${hourDiff} ${hourDiff === 1 ? 'hour' : 'hours'}`
        : `${dayDiff} ${dayDiff === 1 ? 'day' : 'days'}`;

      return `Open in ${displayValue}`;
  }

  const generateStartButton = (assignment) => {
    let state = getAssignmentState(assignment)
    return (
      <h1
        onClick={() => {
          if (checkIfAssignmentCanBeAttended(assignment)) {
            if (assignment.ltiQuizID === "" && !appProperties.isLTIStudent) {
              handleTakeQuizURL(assignment)
            } else {
              handleCarmenAssignmentURL(assignment)
            }

          }
        }}
        className="custom-chip mb-2 font-weight-bold"
        style={{
          backgroundColor: getCustomChipBackgroundColor(assignment),
          color: getCustomChipTextColor(assignment),
          fontSize: "16px",
          cursor:
            checkIfAssignmentCanBeAttended(assignment)
              ? "pointer"
              : "default",
        }}
      >
        {state}
      </h1>
    )
  }



 // console.debug("filteredAssignments", filteredAssignments)

  return (
    <div>
      {/* {activeTabIndex >= 4 && assignments?.length === 0 ? <div>
        <div style={{marginTop:"2rem", textAlign:'center'}}><h1 style={{color:"#BB0000",fontSize:"1.2rem"}}>
        {
          activeTabIndex === 4 ? "You haven't completed any assignments." : "You have not made any practice sets yet. To construct a practice set, go to the “By Assignment” tab and tick the skill categories you want in the set."
        }</h1></div>
      </div> : ''} */}
      {/* <p style={{
        position:"fixed",
        top:0,
        left:0,
        zIndex: 999,
        background:"red",
      }}>
        Current: {currentItem} of {assignments.length}
      </p> */}
      {filteredAssignments && filteredAssignments.length ? filteredAssignments?.map((assignment, assignIndex) => {
          // console.debug("assignmentassignment", assignment)
          return (
            <div
              id={`quiz_id_${assignment.quizID}`}
              ref={(el) => (itemsRef.current[assignIndex] = el)}
              className={` ${assignIndex > 0 ? "mt-4" : ""}`}
              key={assignIndex}
              style={{
                background: isMobile ? "#F9F9F9" : "white",
                scrollBehavior:"smooth",
                // height: isMobile ? "fit-content" : "104px",
              }}
            >
              {/* <small>{assignIndex+1}</small> */}
              {/* Row 1 */}
              <div
                style={{
                  background: "#F9F9F9",
                  borderRadius: "8px",
                  height: isMobile ? "fit-content" : "104px",
                }}
              >
                <Grid className="grid-example">
                  <Cell desktopSize={6} className="p-0 m-0">
                    <Grid
                      className="grid-example cursor-pointer"
                      onClick={() => {
                        if (activeTabIndex >= 4) {
                          setExpandedAssignmentId(assignIndex);
                          handleAssignmentExpand(assignment.quizID);
                        }
                      }}
                    >
                      <Cell
                        desktopSize={4}
                        desktopOffset={activeTabIndex === 1 ? 2 : 1}
                        phoneSize={2}
                        className="d-flex justify-content-around align-items-center"
                      >
                        <div
                          className="mr-4 justify-content-center align-items-center
                                                     cursor-pointer d-none"
                          style={{
                            fontSize: "2rem",
                            height: "30px",
                            width: "30px",
                            color: "#62626280",
                            display: showAnalytics && activeTabIndex >= 4  ? "flex" : "none",
                          }}
                        >
                          {assignment.expand ? (
                            <i className="fas fa-caret-down mx-0"></i>
                          ) : (
                            <i className="fas fa-caret-up mx-0"></i>
                          )}
                        </div>
                        <div>
                          <div>
                            <span className="custom-heading-1 line-h-19px">
                              {activeTabIndex === 5 ? "Practice Set:" : "Assignment:"}
                            </span>
                          </div>
                            <div style={{
                              display: assignment.courseID === -1 ? 'none' : 'block'
                            }}>
                              <span className="custom-heading-1 line-h-19px">
                                Course Name:
                              </span>
                            </div>
                          <div style={{
                            display: activeTabIndex === 5 ? 'none' : 'block'
                          }}>
                            <span className="custom-heading-1 line-h-19px">
                              Start Date:
                            </span>
                          </div>
                          <div style={{
                            display: activeTabIndex === 5 ? 'none' : 'block'
                          }}>
                            <span className="custom-heading-1 line-h-19px">
                              End Date:
                            </span>
                          </div>
                        </div>
                      </Cell>
                      <Cell
                        desktopSize={5}
                        // desktopOffset={1}
                        phoneSize={2}
                        className="d-flex justify-content-start align-items-center"
                      >
                        <div>
                          {assignment.quizName.length > 20 ? 
                            <ReactTooltip
                              id={`quiz_name_${assignIndex}`}
                              multiline={true}
                              place="top"
                              effect="float"
                            />
                          : null}
                          <div className="custom-heading-1-light line-h-19px" style={{
                            whiteSpace:"nowrap",
                            textOverflow:'ellipsis',
                            overflow: 'hidden',
                            width:"150px",
                            position:"relative",
                          }}
                            data-for={`quiz_name_${assignIndex}`}
                            data-tip={assignment.quizName}
                          >
                            {assignment.quizName}
                          </div>

                          {assignment.courseName.length > 17 ? 
                            <ReactTooltip
                              id={`course_name_${assignIndex}`}
                              multiline={true}
                              place="top"
                              effect="float"
                            />
                          : null}

                            <div className="custom-heading-1-light line-h-19px" style={{
                                whiteSpace:"nowrap",
                                textOverflow:'ellipsis',
                                overflow: 'hidden',
                                width:"150px",
                                position:"relative"
                              }}
                              data-for={`course_name_${assignIndex}`}
                            data-tip={assignment.courseName}
                              >
                              {assignment.courseName}
                            </div>
                          <div className="custom-heading-1-light line-h-19px" style={{
                            display: activeTabIndex === 5 ? 'none' : 'block'
                          }}>
                            {moment(assignment.startDate, 'DD/MM/YYYY').format('MM/DD/YYYY')}
                            {/* {assignment.startDate} */}
                          </div>
                          <div className="custom-heading-1-light line-h-19px" style={{
                            display: activeTabIndex === 5 ? 'none' : 'block'
                          }}>
                          {moment(assignment.endDate, 'DD/MM/YYYY').format('MM/DD/YYYY')}
                            {/* {assignment.endDate} */}
                          </div>
                        </div>
                      </Cell>
                    </Grid>
                  </Cell>
                  <Cell desktopSize={6} className="p-0 m-0">
                    {activeTabIndex !== 1 ? (
                      <Grid className="grid-example d-flex justify-content-center align-items-center">
                        <Cell
                          desktopSize={activeTabIndex === 2 ? 8 : 8}
                          tabletSize={activeTabIndex === 2 ? 6 : 5}
                          phoneSize={activeTabIndex === 2 ? 4 : 3}
                        >
                          <div className="">
                          {assignment.courseID !== -1 ?
                            <div>
                              {generateStartButton(assignment)}
                              {/* {appProperties.isLTIStudent ? <small>Please start your assignment from carmen</small> : null} */}
                            </div>
                            
                          : null}
                            {activeTabIndex >= 4 && showAnalytics ? 
                            <div style={{
                              display: assignment.allowPractice && assignment.state !== "Closed" ? 'block' : 'none'
                            }}>
                            <ReactTooltip
                              id={`create_new_practice_set_${assignIndex}`}
                              multiline={true}
                              place="top"
                              // className='tool-tip'
                              effect="float"
                            />
                            <button
                              data-tip={
                                getToolTipForPracticeBtn(assignment)
                              }
                              data-for={`create_new_practice_set_${assignIndex}`}
                              className="custom-chip shadow"
                              style={{
                                //display: assignment.courseID === -1 ? "none": "block",
                                backgroundColor:
                                checkIfAssignmentCanBePracticed(assignment)
                                    ? ( assignment.state === "Completed" && assignment.isMasteryCompleted && assignment.totalAttempts > 0 && assignment.isFinish === 0) || assignment.state === "Resume" ? "#ffdc21" : "#FC543E"
                                    : "gray",
                                fontSize: "16px",
                                fontWeight: "500",
                                color: checkIfAssignmentCanBePracticed(assignment) ? ( assignment.state === "Completed" && assignment.isMasteryCompleted && assignment.totalAttempts > 0 && assignment.isFinish === 0) || assignment.state === "Resume" ? "#333" : "#fff" : '#fff',
                                cursor:
                                checkIfAssignmentCanBePracticed(assignment)
                                    ? "pointer"
                                    : "not-allowed",
                                border: "none",
                                width: "100%",
                                //display: assignment.isFinish === 1 && assignment.allowPractice ? 'block' : 'none'
                              }}
                              // disabled={assignment.state !== "Completed" || assignment.allowPractice === false}
                              onClick={() => {
                                if (checkIfAssignmentCanBePracticed(assignment)) {
                                  handleTakeQuizURL(assignment)
                                }
                                if ((assignment.state === "Completed" || assignment.state === "Closed") && assignment.allowPractice && (assignment.isFinish === 1 && assignment.practiceCount === 0) || assignment.practiceCount > 0) {
                                  // handleTakeQuizURL(assignment)
                                }

                              }}
                            >
                            {(assignment.isMasteryCompleted || assignment.practiceCount === 1) && assignment.isFinish === 0 ? `Resume Practice`: "Start Practice"}
                            {/* {assignment.state === "Completed" ? "Start" : assignment.state} Practice */}
                            </button>
                            </div>
                            : null}
                          </div>
                        </Cell>
                        {activeTabIndex !== 2 ? (
                          <Cell
                            desktopSize={4}
                            tabletSize={2}
                            phoneSize={1}
                            style={{
                              background: "#EAEAEA",
                              borderRadius: "12px",
                              fontSize: isMobile ? "14px" : "16px",
                              cursor: activeTabIndex === 5 ? "pointer" : "auto",
                            }}
                            className="d-flex justify-content-center align-items-center"
                          >
                            {activeTabIndex === 5 ? (
                              <div className="d-flex justify-content-center align-items-center py-2" onClick={() => {
                                handleDeleteQuiz(assignment.quizID)
                              }}>
                                <div className="d-flex flex-column justify-content-center align-items-center text-danger">
                                  <i className="fa-solid fa-trash-can text-danger mb-2 "></i>
                                  <div className="px-1 text-align-center">
                                    Delete Set
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div className="d-flex flex-column justify-content-center align-items-center py-2">
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "16px",
                                    }}
                                  >
                                    Due
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "400",
                                      textAlign: "center",
                                      color: "#000",
                                    }}
                                  >
                                    <div>
                                      {moment(
                                        assignment.endDate,
                                        "DD/MM/YYYY"
                                      ).format("MMM D")}
                                    </div>
                                    <div>
                                      {moment(
                                        assignment.endDate,
                                        "DD/MM/YYYY"
                                      ).format("YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Cell>
                        ) : null}
                      </Grid>
                    ) : (
                      <Grid className="flex justify-content-center align-items-center grid-example">
                        <Cell desktopSize={8} tabletSize={6} phoneSize={4}>
                          <div>
                            <h1
                              className="custom-chip mb-2"
                              style={{
                                backgroundColor: "#2239AB",
                              }}
                            >
                            {getOpenInTime(assignment)}
                              {/* Open in
                              {moment(assignment.startDate, "DD/MM/YYYY").diff(
                                moment(),
                                "days"
                              )}
                              days */}
                            </h1>
                          </div>
                          <div className="text-size-large text-align-center font-weight-bold text-black-50">
                            Due: {assignment.endDate}
                          </div>
                        </Cell>
                      </Grid>
                    )}
                  </Cell>
                </Grid>
              </div>

            {/* TODO Need to add the assignment expand component */}
            {assignment.expand && showAnalytics
              //&& assignment.quizType === 0 
              && activeTabIndex !== 1 ? (
                <React.Fragment>
                  {/* Row 2 */}
                  <div
                    className="mx-3"
                    ref={(el) => (assignmentRefs.current[assignIndex] = el)}
                  >
                    {isMobile ? (
                      <div
                        style={{
                          background: "#F4F4F4",
                          borderRadius: "12px",
                        }}
                        className="my-3 overflow-hidden"
                      >
                        {cells.map((cell, index) => {
                          let name = cell.name;
                          if (index === 0 && activeTabIndex ===5) {
                            name = "Score"
                          }
                          if (assignment.quizType === 1 && index === 0) return
                          return (
                            <div
                              key={`${index}_${cell.name}`}
                              className="d-flex justify-content-around px-4 py-2 text-secondary"
                              style={{
                                background:
                                  index % 2 == 0 ? "#F4F4F4" : "white",
                                overflow: "clip",
                              }}
                            >
                              <div className="w-75 text-size-large font-weight-bolder d-flex justify-content-center align-items-center" style={{
                                height:"20px"
                              }}>
                                {name}
                              </div>
                              <div className="w-25 text-size-large">
                                {getCellValue(cell, assignment)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center my-4">
                        {cells.map((cell, index) => {
                          let name = cell.name;
                          if (index === 0 && activeTabIndex ===5) {
                            name = "Score"
                          }
                          if (assignment.quizType === 1 && index === 0) return
                          return (
                            <div className="custom-cell" key={`${index}_${cell.name}`}>
                              <div>{name}</div>
                              <div className="custom-cell-value">
                                {getCellValue(cell, assignment)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {/* Main Table */}
                  {activeTabIndex !== 1 && assignment.quizType === 0 ? (
                    isMobile ? (
                      <div>
                        {assignment.categories?.map((category, catIndex) => {
                          return (
                            <div
                              key={catIndex}
                              className="py-2"
                              style={{
                                background:
                                  catIndex % 2 == 0 ? "#DEDEDE" : "#E8E8E8",
                              }}
                            >
                              <div
                                className="d-flex justify-content-between align-items-center cursor-pointer"
                                onClick={() => {
                                  setExpandedCategoryId(catIndex);
                                  handleCategoryExpand(assignment.quizID, catIndex);
                                }}
                              >
                                <div
                                  className="ac-heading text-align-left w-100 text-secondary pl-2 d-flex justify-content-start align-items-center py-2"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  <div className="d-none">
                                    {category.expand ? (
                                      <i className="fas fa-caret-down mx-2 d-block"></i>
                                    ) : (
                                      <i className="fas fa-caret-up mx-2 d-block"></i>
                                    )}
                                  </div>
                                  <div
                                    className="d-inline-block"
                                    style={{
                                      fontSize: "16px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#333",
                                        fontWeight: 600
                                      }}
                                    >
                                      {category.label ? category.label : category.name}
                                    </div>
                                  </div>
                                </div>
                                {/* <ReactTooltip
                                  id={`cat_check_icon_${assignIndex}`}
                                  multiline={false}
                                  place="top"
                                  className="tool-tip"
                                  effect="float"
                                />
                                <div
                                  style={{
                                    width: "50px",
                                    textAlign: "center",
                                  }}
                                  data-for={`cat_check_icon_${assignIndex}`}
                                  data-tip="Completed"
                                >
                                  {category.isFinish ? (
                                    <i className="fa-solid fa-check text-secondary"></i>
                                  ) : null}
                                </div> */}
                                {/* <div className="d-flex justify-content-around w-50">
                                  <ReactTooltip
                                    id={`accuracy_index_${assignIndex}`}
                                    multiline={true}
                                    place="top"
                                    className="tool-tip"
                                    effect="float"
                                  />
                                  <div
                                    className="d-none"
                                    data-for={`accuracy_index_${assignIndex}`}
                                    data-tip="An index taking into consideration of the correct and attempted questions for the last attempt"
                                  >
                                    <GaugeChart
                                     color={getColorByAccuracyIndex(
                                                  category
                                                )}
                                      values={getAccuracyIndexes(category)}
                                      width="40px"
                                      text="A"
                                      hideArrow={true}
                                    />
                                  </div>
                                  <ReactTooltip
                                    id={`time_${assignIndex}`}
                                    multiline={true}
                                    place="top"
                                    className="tool-tip"
                                    effect="float"
                                  />
                                  <div
                                    className="d-none"
                                    data-for={`time_${assignIndex}`}
                                    data-tip="Time per question for the last attempt"
                                  >
                                    <GaugeChart
                                     color={getColorByTime(
                                        category
                                      )}
                                      values={getAssignmentTimes(category)}
                                      width="40px"
                                      text="T"
                                      hideArrow={true}
                                    />
                                  </div>
                                </div> */}
                              </div>
                              {category.expand ? (
                                <div
                                  ref={(el) =>
                                    (categoryRefs.current[catIndex] = el)
                                  }
                                >
                                <ReactTooltip
                                      id={`add_practice_2${assignIndex}_${catIndex}`}
                                      multiline={true}
                                      place="top"
                                      effect="float"
                                    />
                                {activeTabIndex === 4 ? 
                                  <div className="ml-2">
                                  <Checkbox
                                    label={
                                      <div style={{
                                        fontSize:"16px",
                                        fontWeight: 500,
                                      }}>
                                        Add to practice
                                      </div>
                                    }
                                        checked={category.addToPractice}
                                        data-tip={assignment.state !== "Completed"
                                          ? "Please complete the mastery attempt first"
                                          : ""}
                                        data-for={`add_practice_2${assignIndex}_${catIndex}`}
                                        className="custom-checkbox"
                                        id={`add_practice_2_${assignIndex}_${catIndex}`}
                                        name={`add_practice_2${assignIndex}_${catIndex}`}
                                        disabled={
                                          assignment.state !== "Completed"  && assignment.state !== "Closed"
                                        }
                                        onChange={(value) => {
                                          handleAddToPractice(
                                            assignment.quizID,
                                            catIndex,
                                            value
                                          );
                                        }}
                                      />
                                  </div>
                                : null}

                                  <div className="pb-2 mt-3">
                                    <Grid className="d-flex justify-content-center grid-example">
                                      <Cell
                                        phoneSize={2}
                                        style={{
                                          background: "#F1F1F1",
                                          borderTopLeftRadius: "12px",
                                          borderBottomLeftRadius: "12px",
                                        }}
                                        className="d-flex justify-content-center flex-column align-items-center text-align-center py-3 m-0 tb-all border-left-0 border-top-0 border-bottom-0"
                                      >
                                        <div>Accuracy (%)</div>
                                        <div className="font-weight-bold text-size-largest" style={{
                                          // fontSize:"2rem"
                                        }}>
                                          {getAccuracyIndexByCategory(category, assignment)}
                                        </div>
                                        {getCategroyAccuracyRemark(category, `${assignment.quizID}_${category.subjectID}_${category.topicID}_${category.categoryID}`)}
                                      </Cell>
                                      <Cell
                                        phoneSize={2}
                                        style={{
                                          background: "#F1F1F1",
                                          borderTopRightRadius: "12px",
                                          borderBottomRightRadius: "12px",
                                        }}
                                        className="d-flex justify-content-center flex-column align-items-center text-align-center py-3 m-0"
                                      >
                                        <div>Time (seconds)</div>
                                        <div className="text-size-largest font-weight-bold">
                                          {getTimeByCategory(category, assignment)}
                                        </div>
                                          {getCategoryTimeRemark(category)}
                                      </Cell>
                                    </Grid>
                                  </div>

                                  <div
                                    className="d-flex justify-content-center align-items-center my-3"
                                    style={{
                                      color: "#464646",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: category.showAccuracy
                                          ? 700
                                          : 400,
                                        fontSize: "20px",
                                      }}
                                    >
                                      Accuracy
                                    </div>
                                    <Toggle
                                      id="accuracy_or_time"
                                      icons={false}
                                      className="mx-3"
                                      checked={!category.showAccuracy}
                                      onChange={() =>
                                        handleCategoryChartChange(
                                          assignment.quizID,
                                          catIndex
                                        )
                                      }
                                    />
                                    <div
                                      style={{
                                        fontWeight: !category.showAccuracy
                                          ? 700
                                          : 400,
                                        fontSize: "20px",
                                      }}
                                    >
                                      Time
                                    </div>
                                  </div>
                                  <div
                                      className="d-flex justify-content-center align-items-center mb-2"
                                      style={{
                                        color: "#464646",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: category.showLineChart
                                            ? 700
                                            : 400,
                                          fontSize: "12px",
                                        }}
                                      >
                                        History
                                      </div>
                                      <Toggle
                                        id="line_or_bar_chart"
                                        icons={false}
                                        className="mx-3 "
                                        checked={!category.showLineChart}
                                        onChange={() =>
                                          handleCategoryChartTypeChange(
                                            assignment.quizID,
                                            catIndex
                                          )
                                        }
                                      />
                                      <div
                                        style={{
                                          fontWeight: !category.showLineChart
                                            ? 700
                                            : 400,
                                          fontSize: "12px",
                                        }}
                                      >
                                        Current
                                      </div>
                                    </div>
                                  <div className="text-align-center mt-2 mx-4">
                                    {/* <div
                                      style={{
                                        fontWeight: 500,
                                        fontSize: "20px",
                                      }}
                                      className="mb-2"
                                    >
                                      {category.showAccuracy
                                        ? "Accuracy Index"
                                        : "Time per Question"}
                                    </div> */}

                                    {category.showAccuracy ? (
                                      category.showLineChart ? 
                                      <LineChart 
                                                  chartName={"Accuracy Index"}
                                                  chartNameTooltip={DashboardTooltips.accuracyIndex}
                                                  labels={getCategoryAccuracyLabels(category)}
                                                  values={getCategoryAccuracyValuesAndColors(category)}
                                                  width="175px"
                                                  height="90px"
                                                  yAxisLabel="%"
                                                />
                                      :
                                      <BarChart
                                        chartNameTooltip={DashboardTooltips.accuracyIndex}
                                        key={assignment.quizName + "accuracy"}
                                        chartName={"Accuracy Index"}
                                        labels={getCategoryAccuracyLabels(category)}
                                        values={getCategoryAccuracyValuesAndColors(category)}
                                        goals={getCategoryAccuracyGoals(category)}
                                        // medianAt={category.timeMedian}
                                        // isLocked={checkIfTimeChartIsLocked(category)}
                                        isLocked={false}
                                        stepSize={0}
                                        showLegend={false}
                                        thickness={25}
                                        width="100px"
                                        height="50px"
                                        min={0}
                                        max={100}
                                        category={category}
                                        handleSetGoal={handleSetGoal}
                                        courseID={assignment.courseID}
                                        assignIndex={assignIndex}
                                        catIndex={catIndex}
                                        quizID={assignment.quizID}
                                        yAxisLable="%"
                                      />
                                      
                                    ) : (
                                      category.showLineChart ? 
                                      <LineChart 
                                                  chartName={"Time"}
                                                  chartNameTooltip={DashboardTooltips.time}
                                                  labels={getCategoryTimeLabels(category)}
                                                  values={getCategoryTimeValues(category)}
                                                  width="175px"
                                                  height="90px"
                                                  yAxisLabel="sec."
                                                />
                                      :
                                      <BarChart
                                        key={assignment.quizName + "time"}
                                        chartName={"Time"}
                                        chartNameTooltip={DashboardTooltips.time}
                                        labels={getCategoryTimeLabels(category)}
                                        values={getCategoryTimeValues(category)}
                                        goals={getCategoryTimeGoals(category)}
                                        isLocked={checkIfTimeChartIsLocked(category)}
                                        medianAt={category.timeMedian}
                                        stepSize={0}
                                        showLegend={false}
                                        thickness={25}
                                        width="100px"
                                        height="50px"
                                        min={0}
                                        max={30}
                                        category={category}
                                        handleSetGoal={handleSetGoal}
                                        courseID={assignment.courseID}
                                        assignIndex={assignIndex}
                                        catIndex={catIndex}
                                        quizID={assignment.quizID}
                                        yAxisLable="sec."
                                      />
                                    )}
                                  </div>
                                    {barChartLabels()}
                                  {/* <div
                                    className="mx-2 mt-4"
                                    style={{
                                      borderRadius: "12px",
                                      background: "#F1F1F1",
                                    }}
                                  >
                                    <p className="p-3 text-align-center m-0">
                                      This is a great start! You may practice
                                      again to improve <b>your accuracy</b>.
                                      Please drag the light purple bar in the
                                      bar chart to <b>set your goal!</b>
                                    </p>
                                  </div> */}
                                </div>
                              ) : null}

                              {/* </div> */}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div>
                        <DataTable plain className="dashboard">
                          <TableHeader className="dashboard-table">
                            <TableRow>
                              <TableColumn className="tb-all border-left-0  border-top-0 border-right-0">
                                <div
                                  className="m-d-col-1 custom-column-header"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  Your Performance
                                </div>
                              </TableColumn>
                              <TableColumn className="pr-0 px-3 tb-all border-left-0 border-right-0 border-top-0 text-align-center">
                              <ReactTooltip 
                                      id={`accuracy_heading_${assignIndex}`}
                                      multiline={true}
                                      place="top"
                                      className='tool-tip tooltip-css'
                                      effect="float" />
                                <div className="m-d-col-1 custom-column-header d-hidden" 
                                  data-for={`accuracy_heading_${assignIndex}`}
                                  data-tip={DashboardTooltips.accuracyIndex}>
                                  <div>Accuracy (%)</div>
                                </div>

                              </TableColumn>
                              <TableColumn className="pr-0 px-3 tb-all border-left-0 border-right-0  border-top-0 text-align-center">
                                <ReactTooltip 
                                        id={`time_heading_${assignIndex}`}
                                        multiline={true}
                                        place="top"
                                        className='tool-tip tooltip-css'
                                        effect="float" />
                                  <div className="m-d-col-1 custom-column-header d-hidden"
                                  data-for={`time_heading_${assignIndex}`}
                                    data-tip={DashboardTooltips.time}>
                                    <div>Time</div>
                                    (seconds)
                                  </div>
                              </TableColumn>
                              {activeTabIndex === 4 ? 
                                <TableColumn className="pr-0 px-3 tb-all border-left-0 border-top-0 border-right-0 text-align-center">
                                  <div className="m-d-col-1 custom-column-header d-hidden">
                                    <div>Add To</div>
                                    <div>Practice</div>
                                  </div>
                                </TableColumn>
                            : null}
                            </TableRow>
                          </TableHeader>
                          {/* <br /> */}
                          <TableBody className="m-d-table-body">
                            {assignment?.categories?.map((category, catIndex) => {
                              return (
                                <React.Fragment>
                                  <TableRow
                                    key={catIndex}
                                    className="position-relative assignment-row"
                                    style={{
                                      background:
                                        catIndex % 2 == 0
                                          ? "#f6f6f6"
                                          : "#eaeaea",
                                      // opacity: !category.attempted ? 0.5 : 1,
                                      border: "none",
                                    }}
                                  >
                                    <TableColumn
                                      className="assignment-col-1 tb-all border-top-0 border-left-0 border-bottom-0 py-2"
                                      style={{
                                        borderTopLeftRadius: "8px",
                                        borderBottomLeftRadius: category.expand
                                          ? 0
                                          : "8px",
                                        cursor: "pointer",
                                        padding: "0rem 1rem",
                                      }}
                                      onClick={() => {
                                        setExpandedCategoryId(catIndex);
                                        handleCategoryExpand(
                                          assignment.quizID,
                                          catIndex
                                        );
                                      }}
                                    >
                                      <div className="d-flex justify-content-around align-items-center">
                                        <div className="ac-heading text-align-left w-100 text-secondary d-flex align-items-center">
                                          <div
                                            className="d-none"
                                            style={{
                                              color: "#62626280",
                                              marginRight: "1rem",
                                            }}
                                          >
                                            {category.expand ? (
                                              <i className="fas fa-caret-up mx-2 fa-xl"></i>
                                            ) : (
                                              <i className="fas fa-caret-down mx-2 fa-xl"></i>
                                            )}
                                          </div>
                                          <div
                                            style={{
                                              color: "black",
                                              fontWeight: category.expand
                                                ? "bold"
                                                : "normal",
                                            }}
                                            className="fontClass-14"
                                          >
                                            {category.label ? category.label : category.name}
                                          </div>
                                        </div>
                                        <ReactTooltip
                                        id={`cat_check_icon_pc_${assignIndex}`}
                                        multiline={false}
                                        place="top"
                                        className="tool-tip"
                                        effect="float"
                                      />
                                        <div
                                          style={{
                                            // width:"50px",
                                            textAlign: "center",
                                          }}
                                          className="mx-4"
                                          data-for={`cat_check_icon_pc_${assignIndex}`}
                                          data-tip="Completed"
                                        >
                                          {category.isFinish ? (
                                            <i className="fa-solid fa-check text-success"></i>
                                          ) : null}
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center">
                                          <div
                                            style={{ marginTop: "-0.5rem" }}
                                            className="mr-4"
                                          >
                                            <ReactTooltip
                                              id={`accuracy_index_${assignIndex}`}
                                              multiline={true}
                                              place="top"
                                              className="tool-tip"
                                              effect="float"
                                            />
                                            <div
                                              className="d-none"
                                              data-for={`accuracy_index_${assignIndex}`}
                                              data-tip="An index taking into consideration of the correct and attempted questions for the last attempt"
                                            >
                                              <GaugeChart
                                                color={getColorByAccuracyIndex(
                                                  category
                                                )}
                                                values={getAccuracyIndexes(category)}
                                                width="50px"
                                                text="A"
                                              />
                                            </div>
                                          </div>
                                          <div style={{ marginTop: "-0.5rem" }}>
                                            <ReactTooltip
                                              id={`time_${assignIndex}`}
                                              multiline={true}
                                              place="top"
                                              className="tool-tip"
                                              effect="float"
                                            />
                                            <div
                                              className="d-none"
                                              data-for={`time_${assignIndex}`}
                                              data-tip="Time per question for the last attempt"
                                            >
                                              <GaugeChart
                                                color={getColorByTime(
                                                  category
                                                )}
                                                values={getAssignmentTimes(category)}
                                                width="50px"
                                                text="T"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </TableColumn>
                                    {category.expand ? <TableColumn colSpan={3}></TableColumn> : 
                                      <React.Fragment>
                                      <TableColumn className="text-align-center p-0 tb-all border-bottom-0 border-top-0 py-2" 
                                    style={{
                                      opacity: category.expand ? 0 : 1
                                    }}>
                                      <div>
                                        <small className="text-secondary">Accuracy Index:</small>
                                        <div className="fontClass-22"> {getAccuracyIndexByCategory(category, assignment)}</div>
                                      </div>
                                      <div className="fontClass-18">
                                        {getCategroyAccuracyRemark(category, `${assignment.quizID}_${category.subjectID}_${category.topicID}_${category.categoryID}`)}
                                      </div>
                                    </TableColumn>
                                    <TableColumn className="text-align-center p-0 tb-all border-bottom-0 border-top-0" style={{
                                      opacity: category.expand ? 0 : 1
                                    }}>
                                      <div>
                                      <small className="text-secondary">Time:</small>
                                      <div className="fontClass-22">{getTimeByCategory(category, assignment)}</div>
                                      </div>
                                      <div className="fontClass-18">
                                      {getCategoryTimeRemark(category)}
                                      </div>
                                    </TableColumn>
                                    {activeTabIndex === 4 ? 
                                    <TableColumn
                                      className="text-align-center p-0 tb-all border-bottom-0 border-top-0 border-right-0 my-goal-col"
                                      style={{
                                        borderTopRightRadius: "8px",
                                        borderBottomRightRadius: category.expand
                                          ? 0
                                          : "8px",
                                          opacity: category.expand ? 0 : 1
                                      }}
                                    >
                                      <div className="justify-content-center align-items-center my-goal-col-div" style={{
                                        // display: category.expand ? 'none' : 'flex'
                                      }}>
                                      <ReactTooltip
                                          id={`add_practice_1${assignIndex}_${catIndex}`}
                                          multiline={true}
                                          place="top"
                                          effect="float"
                                        />
                                        <Checkbox
                                          label="Add to Practice"
                                          checked={category.addToPractice}
                                          data-tip={assignment.state !== "Completed" && assignment.state !== "Closed"
                                            ? "Please complete the mastery attempt first"
                                            : ""}
                                          data-for={`add_practice_1${assignIndex}_${catIndex}`}
                                          className="custom-checkbox"
                                          id={`add_practice_1_${assignIndex}_${catIndex}`}
                                          name={`add_practice_1${assignIndex}_${catIndex}`}
                                          disabled={
                                            assignment.state !== "Completed" && assignment.state !== "Closed"
                                          }
                                          onChange={(value) => {
                                            handleAddToPractice(
                                              assignment.quizID,
                                              catIndex,
                                              value
                                            );
                                          }}
                                        />
                                      </div>
                                    </TableColumn>
                                    : null}
                                      </React.Fragment>
                                    }
                                  </TableRow>
                                  {category.expand && category.attempted ? (
                                    <TableRow
                                      style={{
                                        height: "200px",
                                        border: "none",
                                        background:
                                          catIndex % 2 == 0
                                            ? "#f6f6f6"
                                            : "#eaeaea",
                                      }}
                                    >
                                      {/* <TableColumn></TableColumn> */}
                                      <TableColumn
                                        colSpan={1}
                                        className="tb-all border-left-0 border-top-0 border-bottom-0 p-0"
                                        style={{
                                          borderBottomLeftRadius: "8px",
                                        }}
                                      >
                                          <div className="d-none justify-content-center align-content-center mb-3">
                                            <input type="checkbox" id="showGraded" name="showGraded" placeholder="Show only graded attempts"/>
                                            <div className="fontClass-12 ml-2">
                                              Show only graded attempts
                                            </div>
                                            {/* <Checkbox
                                              label={
                                                <div style={{
                                                  fontSize:"16px",
                                                  fontWeight: 500,
                                                }}>
                                                  Show only graded attempts
                                                </div>
                                              }
                                                  className="custom-checkbox"
                                                  id={`test_${assignIndex}_${catIndex}`}
                                                  name={`test_${assignIndex}_${catIndex}`}
                                                  onChange={(value) => {}}
                                                /> */}
                                          </div>

                                          <div>
                                          <div
                                              className="d-flex justify-content-center align-items-center mb-2"
                                              style={{
                                                color: "#464646",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontWeight: category.showLineChart
                                                    ? 700
                                                    : 400,
                                                  fontSize: "14px",
                                                }}
                                              >
                                                History
                                              </div>
                                              <Toggle
                                                id="line_or_bar_chart"
                                                icons={false}
                                                className="mx-3 "
                                                checked={!category.showLineChart}
                                                onChange={() =>
                                                  handleCategoryChartTypeChange(
                                                    assignment.quizID,
                                                    catIndex
                                                  )
                                                }
                                              />
                                              <div
                                                style={{
                                                  fontWeight: !category.showLineChart
                                                    ? 700
                                                    : 400,
                                                  fontSize: "14px",
                                                }}
                                              >
                                                Current
                                              </div>
                                            </div>
                                          </div>
                                        <div
                                          className="d-flex justify-content-around p-0"
                                          ref={(el) =>
                                            (categoryRefs.current[catIndex] =
                                              el)
                                          }
                                        >
                                          {category.showLineChart ? <>
                                            <Cell size={6} phoneSize={2}>
                                            <LineChart 
                                                  chartName={"Accuracy Index"}
                                                  chartNameTooltip={DashboardTooltips.accuracyIndex}
                                                  labels={getCategoryAccuracyLabels(category)}
                                                  values={getCategoryAccuracyValuesAndColors(category)}
                                                  width="175px"
                                                  height="125px"
                                                  yAxisLabel="%"
                                                />
                                            </Cell>
                                            <Cell size={6} phoneSize={2}>
                                            <LineChart 
                                                  chartName={"Time"}
                                                  chartNameTooltip={DashboardTooltips.time}
                                                  labels={getCategoryTimeLabels(category)}
                                                  values={getCategoryTimeValues(category)}
                                                  width="175px"
                                                  height="125px"
                                                  yAxisLabel="sec."
                                                />
                                            </Cell>
                                          </> : 
                                             <>
                                              <Cell size={6} phoneSize={2}>
                                                <BarChart
                                                  chartName={"Accuracy Index"}
                                                  chartNameTooltip={DashboardTooltips.accuracyIndex}
                                                  labels={getCategoryAccuracyLabels(category)}
                                                  values={getCategoryAccuracyValuesAndColors(category)}
                                                  goals={getCategoryAccuracyGoals(category)}
                                                  isLocked={false}
                                                  medianAt={0}
                                                  stepSize={0}
                                                  showLegend={false}
                                                  thickness={20}
                                                  width="175px"
                                                  height="125px"
                                                  min={0}
                                                  max={100}
                                                  category={category}
                                                  handleSetGoal={handleSetGoal}
                                                  courseID={assignment.courseID}
                                                  assignIndex={assignIndex}
                                                  catIndex={catIndex}
                                                  quizID={assignment.quizID}
                                                  yAxisLable="%"
                                                />
                                            </Cell>
                                            <div className="vertical-divider">
                                            </div>
                                            <Cell size={6} phoneSize={2}>
                                              <BarChart
                                                chartName={"Time"}
                                                chartNameTooltip={DashboardTooltips.time}
                                                labels={getCategoryTimeLabels(category)}
                                                values={getCategoryTimeValues(category)}
                                                goals={getCategoryTimeGoals(category)}
                                                isLocked={checkIfTimeChartIsLocked(category)}
                                                medianAt={category.timeMedian}
                                                stepSize={0}
                                                showLegend={false}
                                                thickness={20}
                                                width="175px"
                                                height="125px"
                                                min={0}
                                                max={getTheMaxTime(category)}
                                                category={category}
                                                handleSetGoal={handleSetGoal}
                                                courseID={assignment.courseID}
                                                assignIndex={assignIndex}
                                                catIndex={catIndex}
                                                quizID={assignment.quizID}
                                                yAxisLable="sec."
                                              />
                                            </Cell>
                                          </>
                                          }
                                          

                                        </div>
                                        {barChartLabels()}
                                      </TableColumn>
                                      <TableColumn
                                        colSpan={3}
                                        style={{
                                          borderBottomRightRadius: "8px",
                                          borderCollapse: "separate",
                                          perspective: "1px",
                                          overflow: "hidden",
                                        }}
                                        className="p-0"
                                      >
                                        <div className="text-center d-flex flex-column justify-content-start h-100 mt-5">

                                          <Grid className='w-100' >
                                            <Cell size={6} tabletSize={4}>
                                              <div>
                                                <h4>Accuracy Index</h4>
                                                <h1 className="text-black">{getAccuracyIndexByCategory(category, assignment)}</h1>
                                              </div>
                                              <div className="fontClass-20">
                                                {getCategroyAccuracyRemark(category, `${assignment.quizID}_${category.subjectID}_${category.topicID}_${category.categoryID}`)}
                                              </div>
                                            </Cell>
                                            <Cell size={6} tabletSize={4}>
                                              <div>
                                                <h4>Time</h4>
                                                <h1 className="text-black">{getTimeByCategory(category, assignment)}</h1>
                                              </div>
                                              <div className="fontClass-20">
                                                {getCategoryTimeRemark(category)}
                                              </div>
                                            </Cell>
                                          </Grid>
                                          <div className="px-2 py-2 cursor-pointer mx-5"  style={{
                                              background:"#D9D9D9",
                                              borderRadius:"12px",
                                              display: activeTabIndex === 5 ? 'none' : 'block'
                                              }}>
                                          <Checkbox
                                            label={<div className="fontClass-14 font-weight-bolder text-left">
                                              Add to Practice Set
                                            </div>}
                                            checked={category.addToPractice}
                                            data-tip={assignment.state !== "Completed" && assignment.state !== "Closed"
                                              ? "Please complete the mastery attempt first"
                                              : ""}
                                            data-for={`add_practice_1${assignIndex}_${catIndex}`}
                                            className="custom-checkbox"
                                            id={`add_practice_1_${assignIndex}_${catIndex}`}
                                            name={`add_practice_1${assignIndex}_${catIndex}`}
                                            disabled={
                                              assignment.state !== "Completed" && assignment.state !== "Closed"
                                            }
                                            onChange={(value) => {
                                              handleAddToPractice(
                                                assignment.quizID,
                                                catIndex,
                                                value
                                              );
                                            }}
                                        />
                                        </div>
                                        <div style={{
                                          width:'100%',
                                          textAlign:'center',
                                          display: activeTabIndex === 5 && assignment.state === 'Start'  ? 'flex' : 'none'
                                        }} className="fontClass-16 justify-content-center align-items-center">
                                            <div style={{
                                              width:'90%',
                                              backgroundColor:'#d9d9d9',
                                              
                                            }} className="p-4 rounded-pill">
                                              Start working on your practice. The data will be shown once a wheel has been completed.
                                            </div>
                                        </div>
                                        </div>
                                      </TableColumn>
                                    </TableRow>
                                  ) : null}
                                </React.Fragment>
                              );
                            })}
                          </TableBody>
                        </DataTable>
                      </div>
                    )
                  ) : null}
                </React.Fragment>
              ) : null}
            </div>
          );
        }): null}
    </div>
  );
};

export default DashboardCard;
